var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPreview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 4.375L8.75 1.25M8.75 1.25H6.89453M8.75 1.25V3.10547",
    stroke: "#616161",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5C8.75 6.76777 8.75 7.65165 8.20083 8.20083C7.65165 8.75 6.76777 8.75 5 8.75C3.23223 8.75 2.34835 8.75 1.79917 8.20083C1.25 7.65165 1.25 6.76777 1.25 5C1.25 3.23223 1.25 2.34835 1.79917 1.79917C2.34835 1.25 3.23223 1.25 5 1.25",
    stroke: "#616161",
    strokeWidth: 0.9375,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/preview.a458e9d90aec7a629b33c1e9bb8dc889.svg";